<template>
  <div id="modalAddTemplate" class="modal-dialog myModal-dialog" v-if="showDialog">
    <div class="modalHeader">
      <span class="title">Add Empty Template</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label for="templateName" class="font14"><b>Template Name</b></label>
        <input class="form-control form-control-sm" type="text" id="templateName" v-model="templateName">
      </div>
      <button class="btn btn-success" @click="addTemplate">Add</button>
      <button class="btn btn-danger" @click="closeModal">Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-add-template',

  data () {
    return {
      showDialog: false,
      templateName: ''
    }
  },

  mounted () {
    let that = this
    this.$bus.on('showTemplateAddDialog', function () {
      that.showDialog = true
    })
  },

  methods: {
    closeModal () {
      this.showDialog = false
      this.templateName = ''
    },

    addTemplate () {
      let templateData = {
        formId: this.$store.state.currentFormId,
        name: this.templateName,
        pages: {}
      }

      for (let i = 1; i < Object.keys(this.$store.state.templates['global']['pages']).length + 1; i++) {
        templateData.pages[i] = []
      }

      const apiUrl = this.$store.state.apiUrl
      this.axios.post(apiUrl + 'template/add', templateData).then(response => {
        if (response.data.success) {
          templateData['_id'] = response.data.id

          this.axios.post(apiUrl + 'questionnaire/add', {templateId: response.data.id}).then(response => {
            if (response.data.success) {
              templateData['questionnaire_id'] = response.data.id
              this.$store.commit('addTemplate', {
                id: templateData.name,
                data: templateData
              })

              this.$store.commit('addQuestionnaire', {
                index: templateData.name,
                data: {
                  '_id': response.data.id,
                  templateId: templateData['_id'],
                  data: {}
                }
              })

              this.$bus.emit('addNotification', {
                title: 'Template Created',
                body: 'The template was created successfully',
                type: 'success'
              })

              // Reactivity Hacks
              this.$store.commit('setShowAnnotationMenu', true)
              this.$store.commit('setDrawAnnotations', true)
              this.$store.commit('setShowBottomMenu', false)
              this.$store.commit('setShowAnnotationMenu', false)
              this.$store.commit('setDrawAnnotations', false)
              this.$store.commit('setShowBottomMenu', true)
              this.closeModal()
            } else {
              this.$bus.emit('addNotification', {
                title: 'Template Questionnaire Error',
                body: 'There was an error creating the template questionnaire. Please review the data and try again',
                type: 'error'
              })
            }
          })
        } else {
          this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error creating the template. Please review the data and try again',
            type: 'error'
          })
        }
      })
    }
  },

  beforeDestroy () {
    this.$bus.$off('showTemplateAddDialog')
  }
}
</script>

<style lang="scss" scoped>
  .modal-dialog {
    user-select: none;
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -25%;
    width: 50%;
    height: 175px;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    overflow: hidden;
    z-index: 1;

    .modalHeader {
      background-color: #2d5f8b;
      color: white;
      font-size: 18px;
      padding: 5px 10px 5px 10px;

      .btn-close {
        cursor: pointer;
        color: #FFF;
      }
    }

    .modalBody {
      padding: 10px;
    }
  }

  .myModal-dialog{
    pointer-events: auto !important;
    max-width: 760px !important;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/modals/ModalAddTemplate.vue